
export const imageUpscaler = {
    // Page title and subtitle
    title: 'AI 图片放大器',
    subtitle: '使用 AI 驱动的放大技术增强您的图片',
    
    // Upload section
    details: '上传详情',
    uploadText: '上传图片开始使用',
    uploadFormats: '支持 JPG、PNG、WebP 格式，最大 10MB',
    uploadImageFirst: '请先上传图片',
    
    // Settings
    factor: '放大倍数',
    faceEnhancement: '面部增强',
    enhanceTypes: '增强类型',
    
    // Enhancement type options
    denoise: '降噪',
    face_enhance: '面部增强',
    sharpen: '锐化',
    color_enhance: '色彩增强',
    detail_enhance: '细节增强',
    
    // Actions
    enhance: '增强图片',
    processing: '处理中',
    downloadButton: '下载增强图片',
    
    // Preview section
    preview: '预览',
    processingOverlay: '正在处理您的图片...',
    noImageUploaded: '未上传图片',
    resultTitle: '增强结果',
    
    // Features section
    featuresTitle: '强大功能',
    feature1Title: 'AI 驱动增强',
    feature1Desc: '先进的 AI 算法在保持细节的同时增强图片质量。',
    feature2Title: '多种放大倍数',
    feature2Desc: '选择 2x、4x 或 8x 放大以满足您的特定需求。',
    feature3Title: '面部增强',
    feature3Desc: '专门的面部增强技术，适用于人像照片。',
    feature4Title: '高质量输出',
    feature4Desc: '专业级结果，适用于印刷和数字使用。',
    
    // How to use section
    howToUseTitle: '使用方法',
    step1Title: '上传图片',
    step1Desc: '选择并上传您的图片文件（JPG、PNG 或 WebP 格式）。',
    step2Title: '选择设置',
    step2Desc: '选择放大倍数，如需要可启用面部增强。',
    step3Title: '下载结果',
    step3Desc: '处理您的图片并下载增强版本。',
    
    // FAQ section
    faqTitle: '常见问题',
    faq1: '支持哪些图片格式？我们支持 JPG、PNG 和 WebP 格式。',
    faq2: '最大文件大小是多少？每张图片的最大文件大小为 10MB。',
    faq3: '处理需要多长时间？处理通常需要 30-60 秒，取决于图片大小和设置。',
    
    // Footer
    footerCopyright: '© 2025 Catoo. 保留所有权利。',
    
    // Error messages
    loginExpired: '登录会话已过期。请重新登录。',
    imageUpscaleFailed: '图片放大失败。请重试。',
    networkError: '网络错误。请检查您的连接并重试。',
    queryStatusFailed: '查询处理状态失败。',
    processingTimeout: '处理超时。请重试。',
    downloadFailed: '下载失败。请重试。',
    
    // Success messages
    imageUpscaleComplete: '图片放大成功完成！'
  };
